module.exports = __webpack_public_path__ + "static/media/live-view-preview.6835e602.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/live-view-preview.svg
// module id = b9qL
// module chunks = 89